module.exports = "/_next/static/images/sizeidForBusiness-b5f72f77537c94480b2482583834b41a.png";